import { EventBusType } from '@/modules/EventBus/EventBusType';
import Vue from 'vue';

export const emitBusEvent = (type: EventBusType, payload?: any) => Vue.bus.emit(type, payload);